import * as React from "react";
/* empty css                             */
const UnpublishedProductImage = ({ src, alt }) => /* @__PURE__ */ React.createElement("img", { className: "unpublished-product-image", src, alt });
export {
  UnpublishedProductImage
};
//# sourceMappingURL=UnpublishedProductImage.js.map
